let initialState = {
	ormWidgetStatus: null,
};
const OrmDataPersist = (state = initialState, action) => {
	switch (action.type) {
		case "SET_ORM_WIDGET_STATUS":
			return {
				...state,
				ormWidgetStatus: action.payload,
			};

		default:
			return state;
	}
};

export default OrmDataPersist;
